export const TYPE_FREE = 'FREE' as const;

// Fossilizer types
export const EVIDENCE_BATCH_FOSSILIZER = 'batchfossilizer' as const;

// Type of references
export const REFERENCES = 'REFERENCES' as const;
export const REFERENCED_BY = 'REFERENCED_BY' as const;
